export * from './MobilePhoneIcon';
